import React, { useEffect } from 'react';
import './HowItWorksSection.css';
import { Link } from 'react-router-dom';

export default function HowItWorksSection(){
  useEffect(() => {
    const steps = Array.from(document.querySelectorAll('.m-how-step'));
    if (!steps.length) return;
    // Add reveal base class
    steps.forEach((s,i) => {
      s.classList.add('reveal');
      s.style.setProperty('--reveal-delay', `${i * 60}ms`);
    });
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
        }
      });
    }, { threshold: 0.25 });
    steps.forEach(s => obs.observe(s));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="how-it-works" className="snap-section m-how m-wrapper section-organized" aria-labelledby="m-how-title" data-section="how">
      {/* Decorative overlays */}
      <div className="organized-pattern" aria-hidden></div>
      <div className="organized-top-seam" aria-hidden></div>
      <div className="organized-bottom-fade" aria-hidden></div>
  <h2 id="m-how-title" className="m-how-h"><span className="how-plain">How Scout Keeps You </span><span className="how-accent">Organized.</span></h2>
  {/* Subheading intentionally removed per latest request */}
      <div className="m-how-grid" aria-label="Timeline steps">
        {/* Stage container with rail + cards */}
        <div className="m-how-stage" aria-label="Process steps">
          <div className="how-rail" aria-hidden>
            <div className="how-rail-spotlight" aria-hidden></div>
            <div className="how-rail-line"></div>
          </div>
          <ol className="m-how-steps">
          <li className="m-how-step">
            <div className="m-step-card">
              <div className="m-step-icon step-1" aria-hidden>📥</div>
              <div className="m-step-content">
                <div className="m-step-title">Upload</div>
                <p className="m-step-desc">Drop your syllabus — Scout instantly extracts assignments, exams, and readings.</p>
              </div>
            </div>
          </li>
          <li className="m-how-step">
            <div className="m-step-card">
              <div className="m-step-icon step-2" aria-hidden>🕒</div>
              <div className="m-step-content">
                <div className="m-step-title">We Organize</div>
                <p className="m-step-desc">AI builds your calendar and keeps it synced as professors update materials.</p>
              </div>
            </div>
          </li>
          <li className="m-how-step">
            <div className="m-step-card">
              <div className="m-step-icon step-3" aria-hidden>🗨️</div>
              <div className="m-step-content">
                <div className="m-step-title">Chat & Plan</div>
                <p className="m-step-desc">Ask Scout anything about your classes. Plan smarter, faster, and stress-free.</p>
              </div>
            </div>
          </li>
          </ol>
        </div>
        {/* Right hint / CTA */}
        <div className="how-hint-wrap">
          <div className="how-hint-text">Start your first upload — it takes less than a minute →</div>
          <div className="how-hint-sub">Scout takes it from here; your semester is already in motion.</div>
          <div className="how-hint-cta">
            <Link to="/m/register" className="m-how-cta cta-shine-init" aria-label="Start your first upload – it takes less than a minute">Begin Upload</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
